/**
 * useStaffActivity
 *
 * Infinite (cursor-paginated) feed of a staff member's token wallet
 * movements — purchases, grants, debt payments and peer transfers.
 * Backs the staff wallet activity list.
 */

import { useInfiniteQuery } from '@tanstack/react-query';
import { getStaffActivity } from '../services/staffService';
import type { StaffActivityFilters } from '../types';

export const staffActivityKeys = {
  all: ['staff-activity'] as const,
  feed: (staffId: string | null, filters: StaffActivityFilters) =>
    [...staffActivityKeys.all, staffId, filters] as const,
};

export function useStaffActivity(staffId: string | null, filters: StaffActivityFilters = {}) {
  return useInfiniteQuery({
    queryKey: staffActivityKeys.feed(staffId, filters),
    queryFn: ({ pageParam }) =>
      getStaffActivity({ staffId: staffId!, cursor: pageParam, ...filters }),
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
    initialPageParam: undefined as string | undefined,
    enabled: Boolean(staffId),
  });
}
